<template>
<div>
<!--newsletter start-->
      <section class="newsletter2 question">
         <div class="container">
            <div class="row">
               <div class="col-md-12 col-sm-12 ">
                  <div class="heading text-center newsletter1">
                     <h3>Related resources you might like</h3>
                  </div>
                  <br>
                 <div @click="openFirst" class="col-md-4">
                     <div class="quest-text wow animated slideInLeft">
                        <h4>{{posts[firstPost].name}}</h4>
                        <h5>{{posts[firstPost].catagory}}</h5>
                        <p>{{posts[firstPost].summary}}</p>
                        <a>Read More</a>
                     </div>
                  </div>
                  <div @click="openSecond" class="col-md-4">
                     <div class="quest-text wow animated slideInUp">
                        <h4>{{posts[secondPost].name}}</h4>
                        <h5>{{posts[secondPost].catagory}}</h5>
                        <p>{{posts[secondPost].summary}}</p>
                        <a>Read More</a>
                     </div>
                  </div>
                  <div @click="openThird" class="col-md-4">
                     <div class="quest-text wow animated slideInRight">
                        <h4>{{posts[thirdPost].name}}</h4>
                        <h5>{{posts[thirdPost].catagory}}</h5>
                        <p>{{posts[thirdPost].summary}}</p>
                        <a>Read More</a>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
  <!--footer start-->
      <section>
         <div class="section-color-div-footer">
            <div class="container">
               <div class="row">
                  <div v-show="size === false" class="col-md-12 col-sm-12">
                     <div class="container-background">
                        <div class="getone">
                           <h2>Find The Hidden Value Within Your Data</h2>
                           <h5>Organise a chat with us to see how we can help you, no oblegation</h5>
                        </div>
                        <div class="button-text-center">
                           <router-link to="/Contact"><a class="btn btn-pink button7">Get A Quote</a></router-link>
                           <router-link to="/Contact"><a class="btn btn-pink button7">Book A Platform Demo</a></router-link>
                        </div>
                     </div>
                  </div>
                  <br>
                  <div class="col-md-3 col-sm-3">
                     <div class="logo-footer2 wow animated  slideInLeft">
                        <img src="../image/Discovr-Analytics-Logo.png" class="img-responsive" alt="footer-logo">
                        <p><br>50/60 Station Road,<br>Cambridge,<br>CB1 2JH,<br>UK</p>
                     </div>
                  </div>
                  <div class="col-md-3 col-sm-3">
                     <div class="footer-div1 wow animated  slideInUp">
                        <h5>Company</h5>
                        <ul>
                           <li><router-link to="/White-Label-Business-Intelligence-Platform"><a href="#">White-Label BI Platform</a></router-link></li>
                           <li><router-link to="/Content/Case-Studies"><a href="#">Case Studies</a></router-link></li>
                           <li><router-link to="/Content/Guides"><a href="#">Guides</a></router-link></li>
                           <li><router-link to="/Content/Blog"><a href="#">Blog</a></router-link></li>
                           <li><router-link to="/Contact"><a href="#">Contact</a></router-link></li>
                        </ul>
                     </div>
                  </div>
                  <div class="col-md-3 col-sm-3">
                     <div class="footer-div1 wow animated  slideInUp">
                        <h5>Services</h5>
                        <ul>
                           <li><router-link to="/Services/Analytics"><a>Analytics</a></router-link></li>
                           <li><router-link to="/Services/Data-Science"><a>Data Science</a></router-link></li>
                           <li><router-link to="/Services/Machine-Learning"><a>Machine Learning</a></router-link></li>
                           <li><router-link to="/Services/Data-Management"><a>Data Management</a></router-link></li>
                        </ul>
                     </div>
                  </div>
                  <div class="col-md-3 col-sm-3">
                     <div class="footer-div1 wow animated  slideInUp">
                        <h5>Follow Us</h5>
                        <ul>
                           <li><a href="mailto:info@discovranalytics.co">Email Us</a></li>
                           <li><a href="https://www.linkedin.com/company/discovr-analytics/" target="about_">Our LinkedIn</a></li>
                           <li><a href="https://www.instagram.com/discovr.analytics/" target="about_">Our Instagram</a></li>
                           <li><a href="https://twitter.com/DiscovrAnalytic" target="about_">Our Twitter</a></li>
                        </ul>
                     </div>
                  </div>
               </div>
               <hr class="footer12">
               <div class="row">
                  <div class="col-md-6 col-sm-6">
                     <div class="bottom-footer4 wow animated  slideInLeft">
                        <p>© Discovr Analytics Limited 2020 All rights reserved.</p>
                     </div>
                  </div>
                  <div class="col-md-6 col-sm-6">
                     <div class="bottom-footer3 wow animated  slideInRight">
                        <p>
                           <router-link to="/Privacy"><a href="#">Privacy Policy</a></router-link>
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
</div>
</template>

<script>

export default {
  name: 'Nav',
  props: {
    msg: String
  },
  data: function () {
    return {
      scrolled: false,
      posts: [],
      firstPost: 0,
      secondPost: 1,
      thirdPost: 2,
      size: null,
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
    
     const contentful = require("contentful");
     const client = contentful.createClient({
  // This is the space ID. A space is like a project folder in Contentful terms
         space: "055zjod1n9jp",
  // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
         accessToken: "TagtkY-mvVnDjYZExfWoe5ITe-7GUHdI6bwFWTXsOUA"
      });

      client.getEntries({
         'content_type': 'blogPost'
      })
         .then(response => {
                  var postcount = response.items.length
                  this.posts = [];
                    if(postcount > 0 ){
                      response.items.map((postData) =>{
                        this.posts.push({
                          name: postData.fields.title,
                          catagory: postData.fields.catagory,
                          post_id: postData.sys.id
                        })
                      })
                    }
                  })
         .catch(console.error);

         if (screen.width < 700) {
                  this.size = true;
                }
                else {
                 this.size = false;
                }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  } ,
  methods: {
  handleScroll () {
    this.scrolled = window.scrollY > 0;
  },
  openFirst(){
         this.$router.push({ path: ('/Content/Post/'+this.posts[0].name+'?post_id='+this.posts[0].post_id) })
         location.reload(true)
         scrollTo(0,0);
      },
   openSecond(){
         this.$router.push({ path: ('/Content/Post/'+this.posts[1].name+'?post_id='+this.posts[1].post_id) })
         location.reload(true)
         scrollTo(0,0);
      },
   openThird(){
         this.$router.push({ path: ('/Content/Post/'+this.posts[2].name+'?post_id='+this.posts[2].post_id) })
         location.reload(true)
         scrollTo(0,0);
      }
  }, 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
</style>
